module.exports = __webpack_public_path__ + "static/banner-8a5e8ae2ef690fc10b44c140a35a538e.svg";